






































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import SButton from '@/components/UI/SButton.vue';
import { generateUID } from '@/utils/utils';

@Component
export default class SDropdown extends Vue {
  @Prop(Boolean) public disabled?: boolean;
  @Prop(Boolean) public hover?: boolean;
  @Prop(Boolean) public sticky?: boolean;
  @Prop(String) public color?: string;
  @Prop(String) public width?: string;
  @Prop({ type: String, default: 'right' }) public position!: 'left' | 'right';
  @Prop({ type: Boolean, default: false }) public toggleOnLabel!: boolean;
  public open = false;
  private uid = generateUID();

  @Ref() ddButton!: SButton;

  public close() {
    if (this.sticky) return;
    this.setClose();
  }

  @Watch('open')
  private openChanged() {
    if (this.open) {
      this.$emit('open');
    }
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  private toggleDropdown(toggleOnHover = true, open?: boolean) {
    if (!this.disabled && toggleOnHover === this.hover) {
      this.open = typeof open === 'boolean' ? open : !this.open;
    }
  }

  private toggleDropdownFromLabel() {
    if (!this.toggleOnLabel) return;
    this.ddButton.focus();
    this.toggleDropdown(false);
  }

  private setClose() {
    this.open = false;
  }

  private toggleDropdownFromToggleIcon() {
    this.ddButton.focus();
    this.toggleDropdown(false);
  }

  private handleClickOutsideDropdown(event: Event) {
    const path = event.composedPath() as HTMLElement[];
    if (path.some((el: HTMLElement) => el.classList && Array.from(el.classList).includes(`js-dropdown-${this.uid}`))) return;
    this.close();
  }
}
